import React, { FC, FocusEvent, ChangeEvent } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import useFirstUserAction from '../../hooks/useFirstUserActionState';
import CustomTextLabel from '../@shared/customTextLabel';

const CheckboxField: FC<ValueFieldProps> = (props) => {
  const { field, tracker } = props;
  const hasAnyError = !!props.errors?.length;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const label = field.model.title;
  const id = field.valueField.id;
  const name = field.valueField.name;
  const triggerFirstInteractionGTMEvent = useFirstUserAction();

  const onFocus = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onFocusField(field, e?.target?.value);
  };

  const onBlur = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onBlurField(field, e?.target?.value);
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    props.onChange(field.valueField.name, e?.target?.checked as any, props.isValid, []);
    triggerFirstInteractionGTMEvent();
  };

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--checkboxfield ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      }`}
    >
      <input
        id={id}
        name={name}
        className="sitecore-jss-form__field"
        onFocus={onFocus}
        onBlur={onBlur}
        type="checkbox"
        onChange={onChange}
        value={props.value}
        checked={props.value as unknown as boolean}
        form="novalidatedform"
      />
      <label htmlFor={id} className="sitecore-jss-form__control__label--checkbox-label">
        <Icon
          iconName={(props.value as unknown as boolean) ? 'action-checkbox-checked' : 'action-checkbox-default'}
          size={iconSize.dsk}
          color={hasAnyError ? 'error' : undefined}
          extraClassName="sitecore-jss-form__checkbox"
        />
        <CustomTextLabel label={label} tag={'span'} />
      </label>
      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};

export default CheckboxField;
